module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogProductsRecommended":{"heading":"Vybráno pro vás"}},"en":{"CatalogProductsRecommended":{"heading":"Picked for you"}}}')
  delete Component.options._Ctor
}
